<template>
  <UiInputRadioGroupVeeBase v-bind="{ ...$props, ...$attrs }" />
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TValidationRules } from '@team-milva/lab-components'

interface IRadioOption {
  value: string
  text: string
  description?: string
  isDisabled?: boolean
}

export default {
  name: 'UiInputRadioGroupVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    modelValue: { type: String, required: true as const },
    options: {
      type: Array as PropType<IRadioOption[]>,
      required: true as const,
    },
    direction: {
      type: String as PropType<'vertical' | 'horizontal'>,
      default: undefined,
    },
    rules: { type: Array as PropType<TValidationRules[]>, default: undefined },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
  },
}
</script>

<style>
@reference "../../globals/css/base.css";

.s-radio-group {
  @apply items-start gap-2;

  &.s-radio-group--horizontal {
    @apply flex-row items-center gap-4;
  }

  .radio-option {
    @apply rounded-md p-2 hover:bg-surface-muted;
  }

  .radio-option__dot {
    @apply border-border-subtle bg-surface;

    &::after {
      content: '';
      @apply absolute top-1/2 left-1/2 hidden h-2 w-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-text-on-action;
    }
  }

  .radio-option__text {
    @apply pt-px font-medium;
  }

  .radio-option__description {
    @apply text-sm font-normal text-text-secondary;
  }

  .radio-option--disabled {
    @apply pointer-events-none opacity-60;
  }

  .radio-option--checked {
    .radio-option__dot {
      @apply border-action bg-action;

      &::after {
        @apply block;
      }
    }
  }

  .radio-option:not(.radio-option--disabled):hover .radio-option__dot {
    @apply border-action;
  }

  &[data-invalid='true'] .radio-option__dot {
    @apply border-error;
  }
}
</style>
